var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckRojo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M0 0L24 0L24 24L0 24L0 0Z",
    id: "path_1"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "mask_1"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path_1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "checkRojo-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-157 -207.5L-133 -207.5L-133 -183.5L-157 -183.5L-157 -207.5Z",
    id: "checkRojo-4",
    fill: "none",
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "check",
    component: "cd9b081b-2582-4b4d-9e04-4514c6731d68"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0L24 0L24 24L0 24L0 0Z",
    id: "Fondo",
    fill: "#FFFFFF",
    fillOpacity: 0,
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#mask_1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.7966 18.8823C11.2043 18.8823 10.6397 18.624 10.2521 18.1721L5.37075 12.4772C4.63979 11.6242 4.7386 10.3404 5.59161 9.60942C6.44423 8.87765 7.72798 8.97646 8.4598 9.82989L11.651 13.5527L21.7367 1.39083C23.2979 -0.796001 24.9319 0.414974 23.3638 2.61115L13.4514 18.0305C13.0878 18.5394 12.5105 18.8526 11.8861 18.8803C11.856 18.8815 11.8263 18.8823 11.7966 18.8823L11.7966 18.8823Z",
    id: "Forma",
    fill: "#FC4850",
    stroke: "none"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckRojo);
export default __webpack_public_path__ + "static/media/checkRojo.e69e0104eb2e740245e3ab584feba7cc.svg";
export { ForwardRef as ReactComponent };